<template>
    <div class="c-card">
        <div class="ad-item card-item">
            <div class="ad-item card-item">
                <div class="ad-img" style="transform:scale(0.7);transform-origin: 0px 0px;">
                    <div :class="['loyalty-ad-container',{ rotate: rotated }]">
                        <div class="front-box" style="position: relative;" :style="{ height: card.height+'px', width: card.width+'px', backgroundColor: card.faces[0].backgroundColor, fontColor: card.faces[0].fontColor }">  
        
                            <img class="loyalty-ad" :src="card.faces[0].src" style="position: relative" />
                
                            <div class="btns">
                                <div @click="clickBtn(btn)" v-for="(btn,i) in card.faces[0].btns" :key="i">
                                    <component :is="btn.component" :btn="btn" class="ad-btn" :live="true" :style="btn.style"></component>
                                </div> 
                            </div>
        
                        </div>
                        <div v-if="card.faces[1]" class="back-box" :style="{ height: card.height+'px', width: card.width+'px', backgroundColor: card.faces[1].backgroundColor, fontColor: card.faces[1].fontColor }">
                            <img class="loyalty-ad" :src="card.faces[1].src" />
                            <div class="btns">
                                <div @click="clickBtn(btn)" v-for="(btn,i) in card.faces[1].btns" :key="i">
                                    <component :is="btn.component" :btn="btn" class="ad-btn" :live="true" :style="btn.style"></component>
                                </div> 
                            </div>    
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</template>

<script>

import CButton from '@/components/Cards/Button'
import CImage from '@/components/Cards/Image'

export default {
    props: ['card'],
    components: {
        CButton,
        CImage
    },
    data () {
        return {
            rotated: false
        }
    },
    mounted () {
        console.log('this.card',JSON.parse(JSON.stringify(this.card)));
    },
    methods: {
        clickBtn ( btn ) {
            switch ( btn.action ) {
                case 'rotate':
                    return this.rotated = !this.rotated;
            }
            console.log('clickBtn',btn);
        }
    }
}
</script>

<style lang="scss">
.c-card {

}
</style>